
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compiler",
      function () {
        return require("private-next-pages/compiler.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compiler"])
      });
    }
  